var EHDI = EHDI || Object.create(null);

EHDI.popup = EHDI.popup || Object.create(null);

EHDI.popup.PausePopUp = function(isPauseBtn) {
    EHDI.aka.Container.call(this);
    this.pageNumber = 1;

    this.fromPauseBtn = isPauseBtn;

     
    if(EHDI.BrowserInfo.isMobileDevice){
               this.messages = [
                    EHDI.GAME.jsonManager.getLocale("STR_HTP_0"),
                    EHDI.GAME.jsonManager.getLocale("STR_HTP_M_1"),
                    EHDI.GAME.jsonManager.getLocale("STR_HTP_M_2"),
                    EHDI.GAME.jsonManager.getLocale("STR_HTP_3"),
                    EHDI.GAME.jsonManager.getLocale("STR_HTP_4"),
                    EHDI.GAME.jsonManager.getLocale("STR_HTP_5")
                ];
            }
            else{
                this.messages = [
                    EHDI.GAME.jsonManager.getLocale("STR_HTP_0"),
                    EHDI.GAME.jsonManager.getLocale("STR_HTP_D_1"),
                    EHDI.GAME.jsonManager.getLocale("STR_HTP_D_2"),
                    EHDI.GAME.jsonManager.getLocale("STR_HTP_3"),
                    EHDI.GAME.jsonManager.getLocale("STR_HTP_4"),
                    EHDI.GAME.jsonManager.getLocale("STR_HTP_5")
                ];
            }

    this.filePaths = [
        "htp_eden1",
        "htp_eden2",
        "htp_eden3",
        "htp_eden4",
        "htp_eden5",
        "htp_eden6"
    ];
    this.maxPages = this.filePaths.length;
};

EHDI.popup.PausePopUp.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.popup.PausePopUp.prototype.popUpWillAppear = function() {
    
    this.overlay = EHDI.displays.FillRectangle(0x000000, 0, 0, EHDI.GAME.sceneManager.getStageWidth(), EHDI.GAME.sceneManager.getStageHeight(),0);
    
    this.overlay.anchor.set(0.5, 0.5);
    
    this.addChild(this.overlay);
    
    this.position.x = EHDI.GAME.sceneManager.getStageWidth() * 0.5;
    this.bg = new EHDI.aka.Sprite(EHDI.Assets.images["gfx_pop"]);
    this.bg.anchor.set(0.5, 0.5);
    
    this.addChild(this.bg);
   

};

EHDI.popup.PausePopUp.prototype.popUpDidAppear = function() {
    
    this.overlay.alpha = 0.5;
    this.overlay.interactive = true;

    var headerText="";
    if(this.fromPauseBtn){
        headerText = EHDI.GAME.jsonManager.getLocale("STR_PAUSED");
    }
    else{
        headerText = EHDI.GAME.jsonManager.getLocale("STR_HTP");
    }

    this.pausedTxt = new EHDI.displays.TextSprite(headerText);
    this.pausedTxt.anchor.set(0.5, 0.5);
    this.pausedTxt.position.set(-this.bg.width * 0.2, -this.bg.width * 0.24);

    
    
    this.bg.addChild(this.pausedTxt);
    
    this.next = new EHDI.displays.Button(EHDI.Assets.images["btn_prevnext"], EHDI.Assets.images["btn_prevnext2"], null, null);
    
    this.bg.addChild(this.next);
    
    this.next.position.set(this.bg.width * 0.45, 0);
    this.next.setOnClickFunction(this.nextPage.bind(this));
    
    this.page = new EHDI.aka.Container();
    this.bg.addChild(this.page);
    
    var htpImg = new EHDI.aka.Sprite(EHDI.Assets.images[this.filePaths[0]]);
    htpImg.anchor.set(0.5, 0.5);
    htpImg.position.set(0, -this.bg.height * 0.15);
    this.page.addChild(htpImg);

    var htpTxt = new EHDI.displays.TextSprite(this.messages[0]);
    htpTxt.style.wordWrap = true;
    htpTxt.style.wordWrapWidth = htpImg.width * 0.9;
    htpTxt.anchor.set(0.5, 0);
    htpTxt.position.set(0, this.bg.height * 0.05);
    
    this.page.addChild(htpTxt);
    
    this.previous = new EHDI.displays.Button(EHDI.Assets.images["btn_prevnext"], EHDI.Assets.images["btn_prevnext2"], null, null);
    
    this.bg.addChild(this.previous);
    
    this.previous.position.set(-this.bg.width * 0.45, 0);
    this.previous.scale.x = -1;
    this.previous.setOnClickFunction(this.previousPage.bind(this));

    
    this.return = new EHDI.displays.Button(EHDI.Assets.images["btn_return"], EHDI.Assets.images["btn_return2"], null, null);
    
    this.bg.addChild(this.return);
    
    this.return.position.set(0, this.bg.height * 0.35);
    
    this.return.setOnClickFunction(this.resumeGame);
    
    if(this.fromPauseBtn)
    {
        this.exit = new EHDI.displays.Button(EHDI.Assets.images["btn_exit"], EHDI.Assets.images["btn_exit2"], null, null);
        
        this.bg.addChild(this.exit);
        
        this.exit.position.set(-this.bg.width * 0.3, this.bg.height * 0.35);
        this.exit.setOnClickFunction(this.exitGame.bind(this));
        
        this.sound = new EHDI.displays.ToggleButton(EHDI.Assets.images["btn_audio1"], EHDI.Assets.images["btn_audio3"], EHDI.Assets.images["btn_audio2"], EHDI.Assets.images["btn_audio4"], EHDI.GAME.soundManager.getMuted());
        this.sound.setOnClickFunction(this.toggleAudio);
        this.sound.position.set(this.bg.width * 0.3, this.bg.height * 0.35);
        
        this.bg.addChild(this.sound);
    }
};

EHDI.popup.PausePopUp.prototype.popUpWillDisappear = function() {
    this.overlay.alpha = 0;
}

EHDI.popup.PausePopUp.prototype.popUpDidDisappear = function() {
    if(this.htpTxt != null)
    {
        this.page.removeChild(this.htpTxt);
        this.htpTxt.destroy({children: true});
    }
    delete this.htpTxt;

    if(this.htpImg != null)
    {
        this.page.removeChild(this.htpImg);
        this.htpImg.destroy({children: true});
    }
    delete this.htpImg;

    if(this.sound != null)
    {
    this.bg.removeChild(this.sound);
    this.sound.dispose();
    }
    delete this.sound;
    
    if(this.return != null)
    {
        this.bg.removeChild(this.return);
        this.return.dispose();
    }
    delete this.return;

    if(this.previous != null)
    {
    this.bg.removeChild(this.previous);
    this.previous.dispose();
    }
    delete this.previous;
    
    if(this.next != null)
    {
    this.bg.removeChild(this.next);
    this.next.dispose();
    }
    delete this.next;
    
    if(this.exit != null)
    {
    this.bg.removeChild(this.exit);
    this.exit.dispose();
    }
    delete this.exit;

    if(this.pausedTxt != null)
    {
        this.bg.removeChild(this.pausedTxt);
        this.pausedTxt.destroy({children: true});
    }
    delete this.pausedTxt;

    if(this.bg != null)
    {
        this.removeChild(this.bg);
        this.bg.destroy({children: true});
    }
    delete this.bg;

    if(this.overlay != null)
    {
        this.removeChild(this.overlay);
        this.overlay.destroy({children: true});
    }
    delete this.overlay;

    EHDI.GAME.pauseButton.resumeGame();
    this.destroy({children: true});
}

EHDI.popup.PausePopUp.prototype.toggleAudio = function(enable) {
    EHDI.GAME.soundManager.setMute(enable);
    
    EHDI.GAME.soundManager.playSFX("button_sfx");
    EHDI.GAME.saveData.isMuted = enable;
    EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, EHDI.GAME.saveData);
}

EHDI.popup.PausePopUp.prototype.resumeGame = function() {
    EHDI.GAME.soundManager.playSFX("button_sfx");
    EHDI.GAME.sceneManager.popPopUp({y : new EHDI.scene.TransitionParameter(EHDI.GAME.sceneManager.getStageHeight() * 0.5, -EHDI.GAME.sceneManager.getStageHeight()), duration : 0.25});
}

EHDI.popup.PausePopUp.prototype.exitGame = function() {
    EHDI.GAME.soundManager.playSFX("button_sfx");
    EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.ConfirmationPopup(this.goToTitleScreen.bind(this), null), {y : new EHDI.scene.TransitionParameter(EHDI.GAME.sceneManager.getStageHeight(), 0), duration : 0.25});
};

EHDI.popup.PausePopUp.prototype.goToTitleScreen = function() {
    EHDI.GAME.pauseButton.isEndGame = true;
    EHDI.GAME.sceneManager.popPopUp();
    EHDI.GAME.sceneManager.changeScene(new EHDI.scene.TitleScene(), {alpha : new EHDI.scene.TransitionParameter(0,1), duration : 0.25});
};

EHDI.popup.PausePopUp.prototype.nextPage = function() {   
    this.movePage(1);
};

EHDI.popup.PausePopUp.prototype.previousPage = function() {
    this.movePage(-1);
};

EHDI.popup.PausePopUp.prototype.movePage = function(dir)
{
    if(this.transitionTimeline)
        this.transitionTimeline.kill();
    if(this.upcomingPage)
        this.endTransition();
    
    EHDI.GAME.soundManager.playSFX("button_sfx");
    this.upcomingPage = new EHDI.aka.Container();
    this.upcomingPage.alpha = 0;
    this.pageNumber+= dir;

    if(this.pageNumber < 1)
        this.pageNumber = this.maxPages;
    else if(this.pageNumber > this.maxPages)
        this.pageNumber = 1;
    
    var htpImg = new EHDI.aka.Sprite(EHDI.Assets.images[this.filePaths[this.pageNumber - 1]]);
    htpImg.anchor.set(0.5, 0.5);
    htpImg.position.set(0, -this.bg.height * 0.15);
    this.upcomingPage.addChild(htpImg);
    
    var myText = this.messages[this.pageNumber -1];
    
    var htpTxt = new EHDI.displays.TextSprite(this.messages[this.pageNumber -1]);
    htpTxt.style.wordWrap = true;
    htpTxt.style.wordWrapWidth = htpImg.width * 0.9;
    htpTxt.anchor.set(0.5, 0);
    htpTxt.position.set(0, this.bg.height * 0.05);
    
    this.upcomingPage.addChild(htpTxt);
    
    this.transitionTimeline = new TimelineMax();
    this.transitionTimeline.to(this.upcomingPage, 0.5, {alpha : 1});
    this.transitionTimeline.to(this.page, 0.5, {alpha : 0}, 0);
    this.transitionTimeline.add(this.endTransition.bind(this));

    
    
    this.bg.addChild(this.upcomingPage);

}

EHDI.popup.PausePopUp.prototype.endTransition = function() {
    this.page.destroy({children: true});
    this.page = this.upcomingPage;
    this.upcomingPage = null;
    this.page.alpa = 1;    
};